export const regionNameToCamelCase = (value: string): string => {
  return (
    value
      .trim()
      // Replace separators with space
      .replace(/[_\-\s]+/g, ' ')
      // Add space between lowercase → uppercase (SpotRegion → Spot Region)
      .replace(/([a-z])([A-Z])/g, '$1 $2')
      // Add space between letters → numbers (Room3 → Room 3)
      .replace(/([a-zA-Z])(\d)/g, '$1 $2')
      .split(' ')
      .filter(Boolean)
      .map((word, index) => {
        const lower = word.toLowerCase();
        if (index === 0) return lower;
        return lower.charAt(0).toUpperCase() + lower.slice(1);
      })
      .join('')
  );
};

export const formatSpotRegionName = (value: string): string => {
  if (!value) {
    return value;
  }

  const trimmed = value.trim();
  const normalized = trimmed.replace(/[_\-\s]+/g, '');
  const match = normalized.match(/^spotregion(.*)$/i);

  if (!match) {
    return trimmed;
  }

  // When the suffix exists, capitalize the first letter and prefix with an underscore.
  const suffix = match[1];

  if (!suffix) {
    return 'SpotRegion';
  }

  const capitalizedSuffix = suffix.charAt(0).toUpperCase() + suffix.slice(1);

  return 'SpotRegion_' + capitalizedSuffix;
};
